import { SpyneTrait, ViewStream } from "spyne";

export class CodePlaygroundExamplesDomTemplate extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlayground$DomTemplate";

    super(context, traitPrefix);
  }

  static codePlayground$DomTemplateHelloWorld() {
    const data = ["Tyrion", "Arya", "Jon Snow", "Sansa"];
    const style = "font-family:sans-serif;";
    const template = `
                        <h3>Main Characters</h3>
                        
                        <ul>
                           {{#}}
                               <li>{{.}}</li>
                           {{/}}
                         </ul>`;

    //this.appendViewToParentEl(new ViewStream({data,style,template}))

    const onUpdate = () => {
      new ViewStream({ data, style, template }).appendToDom(
        this.props.el.contentDocument.body,
      );
      //this.props.el.contentDocument.body.style="min-height:200px; min-width:200px;";
      //this.props.el.contentDocument.body.innerHTML = "<h1>SDFSDFS</h1>";
      //console.log("CONTENT DOC1 ", this.props.el.contentDocument.body.innerHTML);
    };

    onUpdate();
    //requestAnimationFrame(onUpdate)
    //window.setTimeout(onUpdate, 30);
    // this.props.el.contentDocument.body.appendChild(new DomElementTemplate(template, data).renderDocFrag())
    //this.props.el.contentDocument.body.style = style;
    return `
      const data = ${JSON.stringify(data)};
   
      
      const template = \`${template}\` 
          
      new ViewStream(
        {data,style,template}
      ).appendToDom(document.body);
      

    `;
  }
}
